module.exports = __webpack_public_path__ + "static/media/Maple-Hill-Maintenance-Common-Areas.fc366610.pdf";